import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center space-x-3 cursor-pointer">
              <img
                src="/site-images/a2330e55c0015410f1b6.png"
                alt="Akten Inc Logo"
                className="object-contain"
                style={{ height: '60px', width: 'auto' }}
              />
            </Link>
            <Link
              to="/"
              className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 lg:px-12 py-16">
        <div className="bg-white rounded-lg shadow-sm p-8 lg:p-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
          <p className="text-gray-500 text-sm mb-8">Last Updated: January 2025</p>

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
              <p className="leading-relaxed">
                AKTEN INC ("we," "our," or "us") is a US-based wholesale and marketplace operations company. 
                We are committed to protecting the privacy of our business partners, suppliers, and website visitors. 
                This Privacy Policy explains how we collect, use, and safeguard information in connection with our 
                B2B wholesale and marketplace operations.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Business-Only Operations</h2>
              <p className="leading-relaxed mb-4">
                <strong>Important:</strong> AKTEN INC operates exclusively in the business-to-business (B2B) sector. 
                We do not engage in direct consumer sales or collect personal information from individual consumers 
                for retail purposes.
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>No direct-to-consumer sales activities</li>
                <li>Business contact information collected for partnership evaluation only</li>
                <li>All operations conducted through authorized supply chains</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Information We Collect</h2>
              <p className="leading-relaxed mb-4">
                We collect only business contact information necessary for partnership and supplier evaluation:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>Business name and registration details</li>
                <li>Business contact name and title</li>
                <li>Business email address and phone number</li>
                <li>Business address and operational locations</li>
                <li>Product categories and business capabilities</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. How We Use Information</h2>
              <p className="leading-relaxed mb-4">
                Business information collected is used exclusively for:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>Evaluating potential business partnerships and supplier relationships</li>
                <li>Communicating about wholesale opportunities and marketplace operations</li>
                <li>Supporting wholesale operations and marketplace-related business activities</li>
                <li>Maintaining compliance with trade regulations and authorized supply chains</li>
                <li>Improving our wholesale and distribution services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Data Protection Commitment</h2>
              <div className="bg-[#4A90D9]/10 border-l-4 border-akten p-4 rounded-r-lg mb-4">
                <p className="font-medium text-[#3A78B8]">
                  We do not sell or share personal data with third parties for marketing purposes.
                </p>
              </div>
              <p className="leading-relaxed">
                Your business information is protected through industry-standard security measures. 
                We maintain strict data handling procedures and limit access to authorized personnel only.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Compliance-First Approach</h2>
              <p className="leading-relaxed mb-4">
                AKTEN INC operates with a compliance-first philosophy:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>No arbitrage or gray market activities</li>
                <li>Authorized supply chains only</li>
                <li>Full compliance with US trade regulations</li>
                <li>Transparent business practices with all partners</li>
                <li>Regular compliance audits and reviews</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Data Retention</h2>
              <p className="leading-relaxed">
                We retain business contact information only for as long as necessary to fulfill the purposes 
                outlined in this policy or as required by applicable laws and regulations. Upon termination 
                of a business relationship, we will securely dispose of or anonymize relevant data in accordance 
                with our data retention policies.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Your Rights</h2>
              <p className="leading-relaxed mb-4">
                As a business partner or prospective partner, you have the right to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>Request access to the business information we hold about your company</li>
                <li>Request correction of inaccurate business information</li>
                <li>Request deletion of your business information (subject to legal requirements)</li>
                <li>Opt out of marketing communications</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Contact Us</h2>
              <p className="leading-relaxed mb-4">
                For questions about this Privacy Policy or to exercise your rights, please contact us:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-medium text-gray-900">AKTEN INC</p>
                <p className="text-gray-600">United States of America</p>
                <p className="text-gray-600 mt-2">
                  <a href="mailto:contact@akteninc.com" className="text-akten hover:text-akten-dark cursor-pointer">
                    contact@akteninc.com
                  </a>
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Policy Updates</h2>
              <p className="leading-relaxed">
                We may update this Privacy Policy from time to time to reflect changes in our practices or 
                applicable laws. We will notify our business partners of any material changes through 
                appropriate channels. We encourage you to review this policy periodically.
              </p>
            </section>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Return to Home
          </Link>
        </div>
      </main>

      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <p className="text-gray-400 text-sm">© 2025 AKTEN INC. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
